import { render, staticRenderFns } from "./CartoesPagarme.vue?vue&type=template&id=c4f10406&scoped=true"
import script from "./CartoesPagarme.vue?vue&type=script&lang=js"
export * from "./CartoesPagarme.vue?vue&type=script&lang=js"
import style0 from "./CartoesPagarme.vue?vue&type=style&index=0&id=c4f10406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f10406",
  null
  
)

export default component.exports